import { ConfigProvider, message, Modal } from 'antd';
import ptBR from "antd/lib/locale/pt_BR";

import "../styles/globalStyles.css";

// Variáveis para exportar as APIs
export let modalApi: ReturnType<typeof Modal.useModal>[0];
export let messageApi: ReturnType<typeof message.useMessage>[0];
//export let notificationApi: ReturnType<typeof notification.useNotification>[0]

export const AntdGlobalProvider = ({ children }: { children: React.ReactNode }) => {
  const [mApi, mHolder] = message.useMessage();
  const [mdApi, mdHolder] = Modal.useModal();
  //const [nApi, nHolder] = notification.useNotification();

  // Atribuímos as instâncias para as variáveis exportadas
  messageApi = mApi;
  modalApi = mdApi;
  //notificationApi = nApi;

  return (
      <ConfigProvider locale={ptBR}>
        {mHolder}
        {mdHolder}
        {children}
      </ConfigProvider>
  );
};